import { MealPreference, MealType, RoutineActivity } from '@demind-inc/core';
import { isCustomRecurring } from '../../components/Scheduler/common/recurrence.helpers';

type MealPrefKey = keyof Pick<MealPreference, 'breakfast' | 'lunch' | 'dinner'>;

export const transformRoutineActivityToMealPreference = (
  activities: RoutineActivity[]
): Partial<MealPreference> | undefined => {
  const mealNames = ['breakfast', 'lunch', 'dinner'] as const;
  if (!activities || activities.length === 0) return undefined;

  const mealPref: Partial<MealPreference> = {};

  activities.forEach((activity) => {
    const name = activity.name?.toLowerCase();
    if (name && mealNames.includes(name as (typeof mealNames)[number])) {
      if (isCustomRecurring(activity.recurring)) return;
      mealPref[name as MealPrefKey] = {
        recurring: activity.recurring,
        earliestTime: activity.startTime,
        latestTime: activity.endTime,
        durationMin: activity.durationMin,
      };
    }
  });

  return Object.keys(mealPref).length > 0 ? mealPref : undefined;
};

/**
 * Determines the meal type based on the meal activity name or time
 * @param meal - The meal activity
 * @returns The meal type ('breakfast', 'lunch', 'dinner') or null if undetermined
 */
export const getMealTypeFromName = (name: string): MealType | null => {
  // Check by name first
  if (name.toLowerCase().includes('breakfast')) return 'breakfast';
  if (name.toLowerCase().includes('lunch')) return 'lunch';
  if (name.toLowerCase().includes('dinner')) return 'dinner';

  return null;
};
